import styled, { css } from 'styled-components';
import { darken } from 'polished';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: #fff;
  padding: 10px;
  width: 100%;

  border: 1px solid #bdbdbd;
  border-radius: 6px;

  color: #9e9e9e;

  display: flex;
  align-items: center;
  transition: all 0.35s ease-in-out;

  & + div {
    margin-top: 8px;
  }

  ${(props) =>
    props.isFocused &&
    css`
      color: #003399;
      border-color: #003399;
    `}

  ${(props) =>
    props.isFilled &&
    css`
      color: #003399;
    `}

  svg {
    margin-right: 16px;
  }

  input {
    background: transparent;
    color: #424242;
    flex: 1;
    border: none;

    &::placeholder {
      font-size: 14px;
      font-weight: 400;
      color: #9e9e9e;
    }

    @media only screen and (max-width: 600px) {
      width: 50%;
    }
  }

  select {
    background: transparent;
    padding: 0 10px;
    margin-left: 15px;
    cursor: pointer;

    border: none;
    border-left: 1px solid #bdbdbd;
    font-size: 14px;
    color: #424242;

    @media only screen and (max-width: 600px) {
      width: 35%;
    }
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 17px;
    height: 17px;
    background: transparent;
    border: none;
    margin: 0 2px 0 13px;
    color: #424242;
    transition: all 0.25s ease-in;

    > svg {
      height: 100%;
      width: auto;
      margin-right: 0;

      ${(props) =>
        props.isFocused &&
        css`
          color: #003399;
          border-color: #003399;
        `}

      ${(props) =>
        props.isFilled &&
        css`
          color: #003399;
        `}
    }

    &:hover {
      color: ${darken(0.5, '#424242')};
    }
  }
`;
